(function() {
    'use strict';
    
a3_cabin_reports.factory('CabinReportSyncResultFactory', CabinReportSyncResultFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name CabinReportSyncResultFactory
    * @description 
    *   Manage Cabin Report Sync Results
    * @ngInject
    */
function CabinReportSyncResultFactory(GenericService) {

        /**
        * Initialize the CabinReportSyncResult
        * @memberof CabinReportSyncResultFactory
        */
		function CabinReportSyncResult() {
			this.reportGuid = null;
			this.message = null;
			this.success = null;
			this.FlightAimsId = null;
			this.FlightId = null;
			this.ScheduledDepartureDateUTC = null;
			this.FlightNo = null;
			this.Departure = null;
			this.Arrival = null;
			this.ScheduledDepartureTimeUTC = null;
			this.AcTailNo = null;
			this.Result = null;
			this.getRoute = getRoute;
		}

        /**
        * Get Report Route
        * @memberof CabinReportSyncResultFactory
        * @return {string} route
        */
		function getRoute() {
			if (this.Departure == null && this.Arrival == null) return '-null-';
			else return (this.Departure || '?') + '-' + (this.Arrival || '?');
		}
				
		var objType = 'cabinReportSyncResults';
		var objCallback = CabinReportSyncResult; 
		
		var service = {
			getSyncResult : getSyncResult,
			getCabinReportSyncResultsFromStorage : getCabinReportSyncResultsFromStorage,
			setCabinReportSyncResultsToStorage : setCabinReportSyncResultsToStorage,
			getSuccesses : getSuccesses,
			getFailures : getFailures,
			fromObjectList : fromObjectList
		}
 
        /**
         * Extend an array of Objects from the default CabinReportSyncResult Object
         * @memberof CabinReportSyncResultFactory
         * @param {Array} objList  an Array Of Cabin Report Sync Results
         * @returns {Array} CabinReportSyncResults
         */
		function fromObjectList (objList){
			return GenericService.fromObjectList(objList,objCallback);
		}

        /**
         * Get Sync Result  from given list
         * @memberof CabinReportSyncResultFactory
         * @param {Array} syncResults  an Array Of Cabin Report Sync Results
         * @param {string} reportGuid The report's Guid
         * @returns {object} CabinReportSyncResult
         */
		function getSyncResult(syncResults, reportGuid) {
			if (syncResults == null)
				return null;

			var result = null;
			var arrayLength = syncResults.length;
			for (var i = 0; i < arrayLength; i++) {
				if (syncResults[i].reportGuid == reportGuid) {
					result = syncResults[i];
					break;
				}
			}
			return result;
		};

        /**
         * Get Sync Results
         * @memberof CabinReportSyncResultFactory
         * @returns {array} CabinReportSyncResults
         */
		function getCabinReportSyncResultsFromStorage() {
			return GenericService.list(objType,objCallback);
		}
        
        /**
         * Set Sync Results
         * @memberof CabinReportSyncResultFactory
         * @param {Array} syncResults  an Array Of Cabin Report Sync Results
         */
		function setCabinReportSyncResultsToStorage(cabinReportSyncResults) {
			GenericService.saveAll(cabinReportSyncResults,objType,objCallback);
		}

        /**
         * Get Successfull Sync Results from given syncResult
         * @memberof CabinReportSyncResultFactory
         * @returns {array} successes
         */
		function getSuccesses(syncResults) {
			var result = 0;

			for (var i = 0; i < syncResults.length; i++) {
				if (syncResults[i].success == true) {
					result = result + 1;
				}
			}
			return result;
		}

        /**
         * Get Failed Sync Results from given syncResults
         * @memberof CabinReportSyncResultFactory
         * @returns {array} failures
         */
		function getFailures(syncResults) {
			var result = 0;
			for (var i = 0; i < syncResults.length; i++) {
				if (syncResults[i].success == false) {
					result = result + 1;
				}
			}
			return result;
		}

		return service;
	}

})();